import Select2 from './Select2';
customElements.define('core-select2', Select2,{extends: 'div'});

// Pour surcharge de l'ajout au panier (sélecteur quantité)
import AddToCart from "./AddToCart";

// ✅ nouvelle version sans {extends: 'button'}
if (!customElements.get('add-to-cart-qty')) {
    customElements.define('add-to-cart-qty', AddToCart);
}

import AjaxSwitch from './AjaxSwitch';
customElements.define('ajax-switch', AjaxSwitch, {extends: 'input'});

// Pour surcharge de l'ajout au panier (sélecteur quantité)
import ChangeAddToCartToQty from "./ChangeAddToCartToQty";
customElements.define('change-add-to-cart-qty', ChangeAddToCartToQty,{extends: 'div'});

// Surcharge pour prise en compte de l'ancre qui renvoie plus bas vers la description complète
import CollapseLongContent from "./CollapseLongContent";
customElements.define('collapse-long-content', CollapseLongContent);

// Surcharge pour prise en compte de la popup de recherche
import SiteHeader from "./SiteHeader";
customElements.define('site-header', SiteHeader);

// Pour surcharge de la recherche en mode popup
import SearchProducts from "./SearchProducts";
customElements.define('search-products-modal', SearchProducts, {extends: 'div'});

import SwitchView from "./SwitchView";
customElements.define('switch-view', SwitchView, {extends: 'button'});

// Surcharge pour ajout au panier en plus du sélecteur de quantité dynamique
import QuantitySelector from "./QuantitySelector";
customElements.define('quantity-selector', QuantitySelector);

import AddMultipleToCart from './AddMultipleToCart';
customElements.define('add-multiple-to-cart', AddMultipleToCart, {extends: 'table'});

// Surcharge CartLineDeletor
import CartLineDeletor from './CartLineDeletorCatalogue';
customElements.define('cart-line-deletor-catalogue', CartLineDeletor, {extends: 'button'});

// Surcharge CartLineQuantityUpdator
import CartLineQuantityUpdator from './CartLineQuantityUpdatorCatalogue';
customElements.define('cart-line-quantity-updator-catalogue', CartLineQuantityUpdator, {extends: 'input'});

import UpdatePriceTable from "./UpdatePriceTable";
customElements.define('update-price-table', UpdatePriceTable, {extends: 'tr'});

import DraftEdit from "./DraftEdit";
customElements.define('draft-edit', DraftEdit, {extends: 'div'});

import CardQuantityDatesDelivery from "./CardQuantityDatesDelivery";
customElements.define('card-quantity-dates-delivery', CardQuantityDatesDelivery, {extends: 'div'});

import CardDatesDelivery from "./CardDatesDelivery";
customElements.define('card-dates-delivery', CardDatesDelivery, {extends: 'div'});

import ModalCadencierUnique from "./ModalCadencierUnique";
customElements.define('modal-cadencier-unique', ModalCadencierUnique, {extends: 'div'});

import ModalCadencierMultiple from "./ModalCadencierMultiple";
customElements.define('modal-cadencier-multiple', ModalCadencierMultiple, {extends: 'div'});

import CartCommentModal from "./CartCommentModal";
customElements.define('cart-comment-modal', CartCommentModal, {extends: 'div'});

import SelectAddressItem2 from './select-address';
customElements.define('select-address-item-2', SelectAddressItem2,{extends: 'div'});

import CartValidateButton from './CartValidateButton';
customElements.define('cart-validate-button', CartValidateButton, {extends: 'a'});